import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

type FeatureCardProps = {
  title: string;
  description: string;
  icon: LucideIcon;
  index?: number;
};

export function FeatureCard({
  title,
  description,
  icon: Icon,
  index = 0,
}: FeatureCardProps) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.04, 0.24) }}
      whileHover={{ y: -6 }}
      className="group glass-card p-6"
    >
      <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.06] text-electric shadow-[0_0_28px_rgba(30,109,255,0.2)] transition group-hover:border-electric/50 group-hover:text-white">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
      <h3 className="font-display text-xl font-semibold text-white">{title}</h3>
      <p className="mt-3 text-sm leading-6 text-white/60">{description}</p>
    </motion.article>
  );
}
